import script from "./game-content-area.vue?vue&type=script&setup=true&lang=ts"
export * from "./game-content-area.vue?vue&type=script&setup=true&lang=ts"

import "./game-content-area.vue?vue&type=style&index=0&id=0116c3b5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0116c3b5"]])

export default __exports__